/**
 * Determina se un errore rappresenta una reale perdita di connettività di rete
 * (es. `fetch` fallito perché il dispositivo è offline) e NON un errore di
 * risposta del server (RLS, permessi, query non valida, 4xx/5xx).
 *
 * Un errore PostgREST/Supabase valorizzato significa che una risposta HTTP è
 * arrivata: in quel caso siamo online e non dobbiamo marcare l'app offline.
 * Solo i fallimenti di `fetch` (tipicamente `TypeError`) indicano assenza di
 * connettività.
 */
export function isNetworkError(error: unknown): boolean {
  // `fetch` lancia un TypeError quando la richiesta non parte (rete assente).
  if (error instanceof TypeError) {
    return true;
  }

  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  const normalized = message.toLowerCase();

  return (
    normalized.includes('failed to fetch') ||
    normalized.includes('network') ||
    normalized.includes('load failed') ||
    normalized.includes('err_internet_disconnected')
  );
}
